import type { ReportChartProps } from '~/presentation/reports/common/Visualization';

import { LineChart as LineChartComponent } from '@shopify/polaris-viz';
import { AddTimeDimensionPrompt } from './AddTimeDimensionPrompt';
import { ReportChartContainer } from '../ReportChartContainer';
import { GSkeletonDisplayText } from '~/presentation/common';
import { LegendContent } from './LegendContent';
import { useLineChartData } from '../../hooks';
import { isBrowser } from '~/utils';

export type AnalyticLineChartProps = ReportChartProps;

export const LineChart: React.FC<AnalyticLineChartProps> = ({
  isLoading,
  addTimeDimension,
  ...props
}) => {
  const {
    lineChartData,
    xAxisOptions,
    yAxisOptions,
    tooltipOptions,
    seriesKey,
    onlyHasTimeDimension,
    timeDimension,
    seriesNameFormatter,
    setActiveSeriesKey,
  } = useLineChartData(props);

  if (isLoading || !isBrowser()) {
    return <GSkeletonDisplayText height="350px" />;
  }

  if (!timeDimension) {
    return <AddTimeDimensionPrompt addTimeDimension={addTimeDimension} />;
  }

  return (
    <ReportChartContainer>
      <LineChartComponent
        data={lineChartData}
        xAxisOptions={xAxisOptions}
        yAxisOptions={yAxisOptions}
        tooltipOptions={tooltipOptions}
        seriesNameFormatter={seriesNameFormatter}
        theme="Light"
        showLegend
        renderLegendContent={(colorVisionInteractionMethods, activeIndex) => {
          setActiveSeriesKey(activeIndex);

          return (
            <LegendContent
              onlyHasTimeDimension={onlyHasTimeDimension}
              seriesKey={seriesKey}
              data={lineChartData}
              colorVisionInteractionMethods={colorVisionInteractionMethods}
              activeIndex={activeIndex}
            />
          );
        }}
      />
    </ReportChartContainer>
  );
};
